import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";
import { parseDateString } from "../../../../utils/functions";

export const createEmailTemplateFilterValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
    },
  });

  return yup.object().shape(
    {
      isHtml: yup.string(),
      name: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.name.charCount.invalid")),
      nameEn: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.name.charCount.invalid")),
      subject: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.name.charCount.invalid")),
      text: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.name.charCount.invalid")),
      createdDateFrom: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when("createdDateTo", (dateTo, yup) => dateTo && yup.max(dateTo, "validation.createdDate.invalid")),
      createdDateTo: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when("createdDateFrom", (dateFrom, yup) => dateFrom && yup.min(dateFrom, "validation.createdDate.invalid")),
      lastUpdateDateFrom: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when("lastUpdateDateTo", (dateTo, yup) => dateTo && yup.max(dateTo, "validation.lastUpdateDate.invalid")),
      lastUpdateDateTo: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when(
          "lastUpdateDateFrom",
          (dateFrom, yup) => dateFrom && yup.min(dateFrom, "validation.lastUpdateDate.invalid"),
        ),
    },
    [
      ["createdDateFrom", "createdDateTo"],
      ["lastUpdateDateFrom", "lastUpdateDateTo"],
    ],
  );
};
